
import { Brain } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatDate } from './utils';

interface ModalFooterProps {
  insightId: string;
  createdAt: string;
  onClose: () => void;
}

export default function ModalFooter({ insightId, createdAt, onClose }: ModalFooterProps) {
  return (
    <div className="flex justify-between items-center pt-4 border-t">
      <div className="flex items-center space-x-2 text-xs text-muted-foreground">
        <Brain className="h-4 w-4" />
        <span>Análise ID: {insightId?.slice(0, 8)}</span>
        <span>•</span>
        <span>Modelo: OpenAI o3</span>
        <span>•</span>
        <span>Gerado em {formatDate(createdAt)}</span>
      </div>
      <Button onClick={onClose} variant="outline">
        Fechar
      </Button>
    </div>
  );
}
